import { Component, Input } from '@angular/core';

@Component({
  selector: `app-filter-panel`,
  template: `
    <div class="filter-group-title" (click)="panelCollapse = !panelCollapse;" (keyup.enter)="panelCollapse=!panelCollapse">
      <i class="icon pull-right" [ngClass]="{'icon-angle-down': !panelCollapse, 'icon-angle-right': panelCollapse}" [attr.aria-label]="getLabel()" tabindex="0"></i>
      <span tabindex="0">{{title}}</span>
      <i class="fa fa-exclamation-triangle" *ngIf="warning"></i>
      <i class="icon icon-info-circle disableParentAction" tabindex="0" *ngIf="help"
        style="cursor:pointer;"
        popoverTitle="{{title}}"
        placement="right"
        container="body"
        triggers="hover"
        [attr.aria-label]="help"
        [popover]="help">
      </i>
    </div>
    <div [ngClass]="{'collapse': panelCollapse}" aria-expanded="true">
      <ng-content select=".filter-group-content"></ng-content>
    </div>`,
  styleUrls: [`./shared-filter.component.scss`]
})
export class FilterPanelComponent {
  @Input() title: string;
  @Input() warning: boolean;
  @Input() help: string;
  @Input() panelCollapse: boolean;

  getLabel() {
    return this.panelCollapse ? 'Click to expand' : 'Click to collapse';
  }
}
